module.exports = __webpack_public_path__ + "img/csv.c0777cc4.png";